export default "__VITE_ASSET__1933be1a__"